import styled from 'styled-components';

export const AddMrdFormStyle = styled.div`
  .unique-error{
    min-width: 350px!important;
    .unique-error-text{
      color: red;
      vertical-align: super;
    }
  }

  .long-input{
    .irGLIb{
      width: 410px!important;
    }
  }
  .short-input{
    .irGLIb{
      width: 170px!important;
    }
  }

  .form-input-fields{
    min-width: 260px;
    display: table-cell;
    height: 32px;

    .checkbox_wrapper {
      margin-left: -105px !important;
    }
  }

  .left-field-label{
    min-width: 115px!important;
  }

  .mrd-add-form-side-left{
    min-width: 600px;
    width: 50%;
  }
  .mrd-add-form-side-right{
    min-width: 350px;
    width: 50%;
  }
  .mrd-add-form-row{
    width: 100%;
    display: flex;
    align-items: center;
    margin-left: 25px;
  }

  .mrd-add-form-row:first-child{
    margin-top: 10px;
  }
  .mrd-add-form-row:last-child{
    margin-bottom: 10px;
  }

  .css-26l3qy-menu{
    z-index: 2;
  }
`;
